var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTutorialsPlaybook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tutorials-playbook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-tutorials-playbook",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PLAYBOOK",
    transform: "translate(0.500000, 0.500000)",
    fill: "#BDCCD4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6141304,0.0611413043 C28.2540761,0.0611413043 27.8872283,0.0611413043 27.513587,0.0611413043 C22.2350543,0.027173913 17.7649457,1.75951087 15.625,4.34103261 C13.1521739,1.38586957 7.58831522,-0.516304348 1.21603261,0.163043478 L1.21603261,0.163043478 C0.524443007,0.23606393 -0.000367024547,0.819511954 -8.91618309e-06,1.51494565 L-8.91618309e-06,23.8722826 C-0.00138009526,24.2535632 0.157509489,24.6178785 0.437875687,24.8762806 C0.718241884,25.1346826 1.09428177,25.2633898 1.47418478,25.2309783 L1.47418478,25.2309783 C1.96331522,25.1630435 2.49320652,25.1630435 3.05706522,25.1630435 C8.49184783,25.1630435 12.3165761,27.201087 13.3084239,29.1711957 L13.3084239,29.1711957 C13.5397569,29.6302803 14.010382,29.9194912 14.5244565,29.9184809 L15.3668478,29.9184809 C15.8809224,29.9194912 16.3515474,29.6302803 16.5828804,29.1711957 L16.5828804,29.1711957 C17.5747283,27.201087 21.419837,25.1630435 26.8342391,25.1630435 C27.3980978,25.1630435 27.9279891,25.1630435 28.4171196,25.2241848 L28.4171196,25.2241848 C28.7970226,25.2565963 29.1730625,25.1278891 29.4534287,24.8694871 C29.7337949,24.6110851 29.8926844,24.2467697 29.8913133,23.8654891 L29.8913133,1.38586957 C29.8926009,0.666199387 29.3325053,0.070353026 28.6141304,0.027173913 L28.6141304,0.0611413043 Z M10.8695652,21.4470109 L10.8695652,8.4986413 L21.6644022,14.9728261 L10.8695652,21.4470109 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTutorialsPlaybook);
export default __webpack_public_path__ + "static/media/icon-tutorials-playbook.1b077463cfad7fbb776966dd46b5ec30.svg";
export { ForwardRef as ReactComponent };